window._ = require('lodash')
import { datadogLogs } from '@datadog/browser-logs'
import { datadogRum } from '@datadog/browser-rum'

if (process.env.MIX_DATADOG_LOGGING_ENABLED) {
  datadogLogs.init({
    clientToken: process.env.MIX_DATADOG_LOGGING_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: process.env.MIX_DATADOG_SERVICE_NAME,
    version: process.env.MIX_DATADOG_VERSION,
    forwardErrorsToLogs: true,
    forwardConsoleLogs: ['warn', 'error'],
    sessionSampleRate: 100
  })
}

if (process.env.MIX_DATADOG_RUM_ENABLED) {
  datadogRum.init({
    applicationId: process.env.MIX_DATADOG_RUM_APP_ID,
    clientToken: process.env.MIX_DATADOG_RUM_CLIENT_TOKEN,
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: 'datadoghq.com',
    service: process.env.MIX_DATADOG_SERVICE_NAME,
    env: process.env.MIX_DATADOG_ENVIRONMENT,
    // Specify a version number to identify the deployed version of your application in Datadog
    version: process.env.MIX_DATADOG_VERSION,
    sessionSampleRate: 100,
    startSessionReplayRecordingManually: true,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input'
  })
}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios')

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
